import { useState, useCallback } from "react";
import { fetchContactsByClient, fetchClientsByContact } from "../services/contacts.service";

export function useClientExpand() {
  const [expandedClientId, setExpandedClientId] = useState<string | null>(null);
  const [clientContacts, setClientContacts] = useState<any[]>([]);
  const [isContactsLoading, setIsContactsLoading] = useState(false);
  const [expandedContactId, setExpandedContactId] = useState<string | null>(null);
  const [linkedClients, setLinkedClients] = useState<any[]>([]);
  const [isLinkedClientsLoading, setIsLinkedClientsLoading] = useState(false);

  const fetchClientContacts = useCallback(async (clientId: string | null) => {
    if (!clientId) { setClientContacts([]); return; }
    setIsContactsLoading(true);
    try {
      const response: any = await fetchContactsByClient(clientId);
      setClientContacts(response.data || []);
    } catch { setClientContacts([]); }
    finally { setIsContactsLoading(false); }
  }, []);

  const handleToggleClientExpand = useCallback((clientId: string) => {
    setExpandedClientId((prev) => {
      const isExpanding = prev !== clientId;
      if (isExpanding) {
        setExpandedContactId(null);
        fetchClientContacts(clientId);
      }
      return isExpanding ? clientId : null;
    });
  }, [fetchClientContacts]);

  const handleToggleContactExpand = useCallback((contactId: string) => {
    setExpandedContactId((prev) => {
      const isExpanding = prev !== contactId;
      if (isExpanding) {
        setExpandedClientId(null);
        setIsLinkedClientsLoading(true);
        fetchClientsByContact(contactId)
          .then((response: any) => setLinkedClients(response.data || []))
          .catch(() => setLinkedClients([]))
          .finally(() => setIsLinkedClientsLoading(false));
      }
      return isExpanding ? contactId : null;
    });
  }, []);

  return {
    expandedClientId,
    clientContacts,
    isContactsLoading,
    expandedContactId,
    linkedClients,
    isLinkedClientsLoading,
    fetchClientContacts,
    handleToggleClientExpand,
    handleToggleContactExpand,
  };
}
